import React from 'react'
import SubmitButton from '../../Form/SubmitButton/index'

export const ButtonWithTextUnstyled = props => (
  <SubmitButton
    className={props.className}
    onClick={props.onClickHandler}
    value={props.title}
    cypress_id={props.cypress_id}
  >
    <label>{props.label || 'Add user'}</label>
  </SubmitButton>
)
